// badge — default skin module
// NO external imports — plain JavaScript only

const VARIANT_BG = {
  neutral: 'var(--run-badge-neutral-bg, var(--run-color-surface-subtle, #f1f5f9))',
  info:    'var(--run-badge-info-bg,    var(--run-color-intent-info-base,     #3b82f6))',
  success: 'var(--run-badge-success-bg, var(--run-color-intent-success-base,  #22c55e))',
  warning: 'var(--run-badge-warning-bg, var(--run-color-intent-warning-base,  #f59e0b))',
  error:   'var(--run-badge-error-bg,   var(--run-color-intent-danger-base,   #ef4444))',
};

const VARIANT_FG = {
  neutral: 'var(--run-badge-neutral-fg, var(--run-color-text-primary,          #334155))',
  info:    'var(--run-badge-info-fg,    var(--run-color-feedback-info-foreground,       #ffffff))',
  success: 'var(--run-badge-success-fg, var(--run-color-feedback-success-foreground,    #ffffff))',
  warning: 'var(--run-badge-warning-fg, var(--run-color-feedback-warning-foreground,    #ffffff))',
  error:   'var(--run-badge-error-fg,   var(--run-color-intent-danger-on,     #ffffff))',
};

const SIZE_FONT = {
  sm: 'var(--run-font-size-xs, 11px)',
  md: 'var(--run-font-size-xs, 12px)',
  lg: 'var(--run-font-size-sm, 14px)',
};

const SIZE_PADDING = {
  sm: '1px 6px',
  md: '2px 8px',
  lg: '3px 10px',
};

const SIZE_HEIGHT = {
  sm: '18px',
  md: '20px',
  lg: '24px',
};

export const styles = `
  :host {
    display: inline-flex;
    vertical-align: middle;
  }
`;

export function render(host) {
  const { variant, size, pill, dot } = host;
  const bg      = VARIANT_BG[variant]  || VARIANT_BG.neutral;
  const fg      = VARIANT_FG[variant]  || VARIANT_FG.neutral;
  const fs      = SIZE_FONT[size]      || SIZE_FONT.md;
  const padding = SIZE_PADDING[size]   || SIZE_PADDING.md;
  const height  = SIZE_HEIGHT[size]    || SIZE_HEIGHT.md;
  const radius  = pill
    ? 'var(--run-badge-border-radius, var(--run-radius-semantic-pill, 9999px))'
    : 'var(--run-badge-border-radius, var(--run-radius-semantic-badge, 4px))';

  if (dot) {
    const dotSize = size === 'sm' ? '6px' : size === 'lg' ? '10px' : '8px';
    host.shadowRoot.innerHTML = `
      <span part="badge" style="
        display: inline-block;
        width: ${dotSize};
        height: ${dotSize};
        border-radius: 9999px;
        background: ${bg};
        flex-shrink: 0;
      "></span>
    `;
    return;
  }

  host.shadowRoot.innerHTML = `
    <span part="badge" style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: ${height};
      min-width: ${height};
      padding: ${padding};
      font-size: ${fs};
      font-weight: var(--run-font-semantic-weight-medium, 500);
      font-family: var(--run-font-semantic-family-body, inherit);
      line-height: 1;
      color: ${fg};
      background: ${bg};
      border-radius: ${radius};
      white-space: nowrap;
      box-sizing: border-box;
    "><slot></slot></span>
  `;
}
